
import styled from 'styled-components'

export const DropZone = styled.div`
    border: 1px dotted ${props => props.theme.color.color100};
    padding: 16px;
    background: ${props => props.disabled ? '#fff7f7' :  props.theme.color.color0};
`